
// NATIVE 


// INSTALLED 

// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";
import { checkingPreload, unCheckingPreload } from "../store/loading";


const http = new AxiosAdapter();





export const getCargosService = async() => {

    try {

        return await http.get<any>(`/v1/position`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getCargosService ',error)
    }
}



export const getCargosSelectService = async() => {

    try {

        return await http.get<any>(`/v1/position/select`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getCargosSelectService ',error)
    }
}



export const getCargosByPaginateService = async(page:number) => {
   
    try {

        return await http.get<any>(`/v1/position?page=${page}&take=10`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getCargosByPaginateService ',error)
    }
}


export const createCargoService = async(cargo:object, setPercentajeCCompany:any) => {
   
    try {
        
        return await http.post<any>('/v1/position', cargo, setPercentajeCCompany); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('createCargoService ',error);

    }
}




export const getCargoDetailService = async(cargoId:string) => {
   
    try {

        return await http.get<any>(`/v1/position/${cargoId}`); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getCargoDetailService ',error);

    }
}



export const updateCargoDetailService = async(cargo: object) => {
   
    try {

        return await http.put<any>(`/v1/position`, cargo); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('updateCargoDetailService ',error);

    }
}



export const desactiveCargoService = async(cargoId: string) => {
   
    try {

        return await http.delete<any>(`/v1/position/${cargoId}`); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('desactiveCargoService ',error);

    }
}



export const activeCargoService = async(cargoId: string) => {
   
    try {

        return await http.patch<any>(`/v1/position/${cargoId}`); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('activeCargoService ',error);

    }
}
